module.exports = __webpack_public_path__ + "img/hand-move.17d1a7d6.png";